export const getImageV3 = (imageId, size, ext) => {
  // todo remove
  return `https://app.bimclinics.ru/images/g:sm/rs:fill:${size ? size : "1000:1000"}/plain/local:///${imageId}.jpg`;
  // return `/images/g:sm/rs:fill:${size ? size : '1000:1000'}/plain/local:///${imageId}.jpg`;
};
